import * as React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";

/**
 * @param props
 * @returns {JSX.Element | null}
 * @deprecated Prefer using the autoSaveQuestionnaire prop on QuestionnaireContainer components
 */
export const SavingIndicator: React.FunctionComponent<{display: boolean}> = (props) => {
    if (!props.display) {
        return null;
    }
    return (
        <Segment textAlign="center" className="floating-loading-bar">
            <Header>Saving <Icon loading name="spinner" /></Header>
        </Segment>
    );
};
